module.exports = __webpack_public_path__ + "media/images/common/mail_banner-f5c9297aa575f3a7c19659eba0fd0d6b.jpg";